import { render, staticRenderFns } from "./EventAdmins.vue?vue&type=template&id=7d655116"
import script from "./EventAdmins.vue?vue&type=script&lang=ts"
export * from "./EventAdmins.vue?vue&type=script&lang=ts"
import style0 from "./EventAdmins.vue?vue&type=style&index=0&id=7d655116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports